<div class="top-header-filters flex align-items-center gap-3">
  <ng-content select="filters-section" />
  <ng-container *ngIf="gridView$ | async as view">
    @if (view !== "medium" && view !== "small") {
      <div class="top-header-date flex flex-column align-items-start">
        <span
          class="webkit-box-one-line label-small-regular text-inverse-color"
          >{{ dateTime().date }}</span
        >
        <span
          class="webkit-box-one-line label-small-regular text-inverse-color"
          >{{ dateTime().time }}</span
        >
      </div>
    }
  </ng-container>
</div>
